<template>
    <div v-loading="loading">
        <h1 class="title">
            <span class="sub-title" :class="[emailMode ? '' : 'active']" @click="toggleView">工号登录</span>
            <span class="divider"></span>
            <span class="sub-title" :class="[emailMode ? 'active' : '']" @click="toggleView">邮箱登录</span>
        </h1>
        <el-form ref="ruleForm" :rules="rules" :model="ruleForm" autocomplete="off">
            <el-form-item v-if="!emailMode" prop="username" :key="1">
                <el-input v-model="ruleForm.username" placeholder="请输入工号">
                </el-input>
            </el-form-item>
            <el-form-item v-else prop="email" :key="2">
                <el-input v-model="ruleForm.email" placeholder="请输入邮箱前缀">
                    <template slot="append">@corp.netease.com</template>
                </el-input>
            </el-form-item>
            <el-form-item prop="password" :key="emailMode ? 3 : 4">
                <el-input type="password" v-model="ruleForm.password" @keyup.native.enter="submitForm('ruleForm')"
                          placeholder="请输入密码" auto-complete="new-password"></el-input>
            </el-form-item>
            <div class="text-left mb-20">
                <el-checkbox label="记住密码" v-model="remember"></el-checkbox>
            </div>
            <el-form-item>
                <el-button type="primary" size="large" style="width:100%" @click="submitForm('ruleForm')">登录
                </el-button>
            </el-form-item>
            <el-form-item>
                <a :href="`${$axios.defaults.baseURL}/logindoOpenID.html`">
                    <el-button type="text">OpenId登录</el-button>
                </a>
            </el-form-item>
        </el-form>
    </div>
</template>
<script type="text/javascript">
    import { hexMd5 } from './md5'
    import security from './security'
    import myStore from './myStore'
    import sjcl from 'sjcl'

    const exponent = '10001'
    const modulus = '009bd7bb03bbdceb1f640f46c1ca855d17ef308c0afd695cfe28ce4cb79d9c6e19f88d13950c391d5463404fce7f8a56a75cbc8585c5979ed0c4f0f0eb090a7355ee673753a0d35f20fbcbc54b5114b32de7a2619627730f36e68dcbb43729b4d0b7e53057adc66a322c8feabb5208a2812b24dabcaae6738685063695efdb83ad'

    export default {
        data () {
            return {
                urls: {
                    login: '/logindo.api'
                },
                ruleForm: {
                    username: '',
                    email: '',
                    password: ''
                },
                remember: false,
                rules: {
                    username: [{required: true, message: '请输入工号', trigger: 'blur'}],
                    email: [{required: true, message: '请输入邮箱前缀', trigger: 'blur'}],
                    password: [{required: true, message: '请输入密码', trigger: 'blur'}]
                },
                emailMode: false,
                loading: false
            }
        },
        methods: {
            toggleView () {
                this.emailMode = !this.emailMode
                let ruleName = this.emailMode ? 'email' : 'username'
                if (this.rememberCurrent(ruleName)) {
                    return
                }
                this.ruleForm[ruleName] = ''
                this.ruleForm.password = ''
                this.remember = false
            },
            rememberCurrent (rName) {
                let storeInfo = myStore.get(this.getUnitKey())
                if (storeInfo) {
                    let last = rName ? (this.emailMode ? 'email' : 'user') : storeInfo.last,
                        ruleName = rName || (last === 'email' ? 'email' : 'username'),
                        targetInfo = storeInfo[last]
                    if (!rName) {
                        this.emailMode = (storeInfo.last === 'email')
                    }
                    if (targetInfo) {
                        let name = sjcl.decrypt(modulus, targetInfo._n),
                            pwd = sjcl.decrypt(name, targetInfo._p)
                        this.ruleForm[ruleName] = name
                        this.ruleForm.password = pwd
                        this.remember = true
                        return true
                    }
                }
                return false
            },
            toggleRemember (isRemember) {
                let storeInfo = myStore.get(this.getUnitKey())
                // 当前记住密码
                if (isRemember === true) {
                    let userInfo = {
                        _p: '',
                        _n: this.emailMode ? this.ruleForm.email : this.ruleForm.username
                    }
                    userInfo['_p'] = sjcl.encrypt(userInfo['_n'], this.ruleForm.password)
                    userInfo['_n'] = sjcl.encrypt(modulus, userInfo['_n'])
                    let store = storeInfo || {}  // 记住上次记住密码的mode
                    store['last'] = this.emailMode ? 'email' : 'user'
                    store[store.last] = userInfo
                    myStore.set(this.getUnitKey(), store)
                } else {
                    // 当前不记住密码，则删除已有的记录
                    if (storeInfo) {
                        delete storeInfo[this.emailMode ? 'email' : 'user']
                        storeInfo['last'] = this.emailMode ? 'email' : 'user'
                        myStore.set(this.getUnitKey(), storeInfo)
                    }
                }
            },
            getUnitKey () {
                let key = `_waibao`,
                    projectKey = location.pathname.split('/')[1]
                return projectKey ? `_${projectKey}` : key
            },
            encryPasswd (pwd) {
                let key = window.RSAUtils.getKeyPair(exponent, '', modulus)
                return window.RSAUtils.encryptedString(key, pwd)
            },
            dataProcess () {
                return {
                    username: this.emailMode ? this.ruleForm.email : this.ruleForm.username,
                    passwd: this.emailMode ? hexMd5(this.ruleForm.password) : this.encryPasswd(this.ruleForm.password),
                    type: this.emailMode ? 'email' : 'loginId'
                }
            },
            submitForm (form) {
                this.$refs[form].validate((vaild) => {
                    if (vaild) {
                        this.loading = true
                        this.$axios.post(this.urls.login, this.dataProcess(), {'X-loadingOff': true}).then((res) => {
                            this.loading = false
                            this.toggleRemember(this.remember)
                            if (res.result.project.length > 1) {
                                this.$emit('change', res.result.project)
                            } else {
                                if (res.result.sysConfig.menu.length === 0) {
                                    this.$message({
                                        message: '您还没有访问权限',
                                        type: 'warning'
                                    })
                                    return false
                                }
                                this.$emit('success', res)
                            }
                        }).catch(() => {
                            this.loading = false
                        })
                    } else {
                        console.log('not valid')
                        return false
                    }
                })
            }
        },
        created () {
            this.rememberCurrent()
        }
    }
</script>


// WEBPACK FOOTER //
// main.vue?38529a3e